import useIsAdmin from '@/pages/User/hooks/useIsAdmin.ts'
import { PropsWithChildren, ReactNode } from 'react'
import { AccessRightId } from '@/services/rights/rights.types.ts'
import { useRecoilValue } from 'recoil'
import userSelectors from '@/pages/User/user.selectors.ts'

interface IProps {
  adminOnly?: boolean
  requiredOneOf?: AccessRightId[]
  requiredRight?: AccessRightId
  fallBack?: ReactNode
}

const ProtectedContent = (props: PropsWithChildren<IProps>) => {
  const isAdmin = useIsAdmin()
  const accessRightsSet = useRecoilValue(userSelectors.selectAccessRightsSet)

  if (props.requiredRight && !accessRightsSet.has(props.requiredRight)) return props.fallBack ?? null

  if (props.adminOnly && !isAdmin) return props.fallBack ?? null

  if (props.requiredOneOf && !props.requiredOneOf.some((r) => accessRightsSet.has(r))) {
    return props.fallBack ?? null
  }

  return <>{props.children}</>
}

export default ProtectedContent
